<template>
    <div class="component__slider glide">
        <template v-if="images.length > 1">
            <div class="glide">
                <div class="component__slider_arrows">
                    <div data-glide-el="controls">
                        <button
                            data-glide-dir="<"
                            id="component__slider-button-left"
                        >
                            <v-icon name="chevron-left"/>
                        </button>
                        <button
                            data-glide-dir=">"
                            id="component__slider-button-right"
                        >
                            <v-icon name="chevron-right"/>
                        </button>
                    </div>
                </div>
                <div class="component__slider_slider">
                    <div
                        data-glide-el="track"
                        class="component__slider_slider_track glide__track"
                    >
                        <ul class="component__slider_slider_track_slides glide__slides">
                            <li
                                class="component__slider_slider_track_slide glide__slide"
                                v-for="(image, index) in images"
                                :key="index"
                            >
                                <component-image
                                    :id="image"
                                    :full-height="true"
                                    @click="openPopImage(image)"
                                ></component-image>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="component__slider_dots">
                    <div data-glide-el="controls[nav]">
                        <button
                            v-for="(image, index) in images"
                            :data-glide-dir="`=${index}`"
                            :key="index"
                            id="component__slider-dots-button"
                        ></button>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="component__slider_image">
                <component-image
                    :id="images[0]"
                    :alt="alt"
                    :full-height="true"
                    @click="openPopImage(images[0])"
                ></component-image>
            </div>
        </template>
        <pop-image ref="popimage"/>
    </div>
</template>

<script>
import Glide from '@glidejs/glide'
import PopImage from '@/components/default/shared/PopImage'
import ComponentImage from '@/components/default/shared/ComponentImage'

export default {
  components: { ComponentImage, PopImage },
  name: 'component-slider',
  data () {
    return {
      glide: '',
      settings: {
        type: 'carousel',
        startAt: 0,
        perView: 1,
        autoheight: true
      }
    }
  },
  props: {
    images: {
      type: Array
    },
    alt: {
      type: String
    }
  },
  mounted () {
    if (this.images.length > 1) {
      this.initSlider()
    }
  },
  watch: {
    images () {
      if (this.images.length > 1) {
        this.initSlider()
      }
    }
  },
  methods: {
    openPopImage: function (value) {
      this.$refs.popimage.isActive = true
      this.$refs.popimage.setId(value)
    },
    initSlider () {
      this.glide = new Glide(this.$el, this.settings)
      const self = this
      this.$nextTick(function () {
        setTimeout(() => {
          self.glide.mount()
        }, 500)
      })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/shared/componentslider";
</style>
